import { render, staticRenderFns } from "./smiley.vue?vue&type=template&id=2e499051&scoped=true&"
import script from "./smiley.vue?vue&type=script&lang=js&"
export * from "./smiley.vue?vue&type=script&lang=js&"
import style0 from "./smiley.vue?vue&type=style&index=0&id=2e499051&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e499051",
  null
  
)

export default component.exports